export enum ECampaignType {
    EndOfLifeCycleSale = "endOfLifecycleSale",
    PreOrderOnly = "preOrderOnly",
    RegularCampaign = "regularCampaign",
    Prioritized = "prioritizedProduct",
}
